import React from 'react'
import { Bar, CartesianGrid, ComposedChart, ResponsiveContainer, XAxis, YAxis, Tooltip } from 'recharts'
import { formatNumberWithCommas } from '../../../utils/utils';
import { CustomTooltipPowerSteering, findMinMax } from "../ChartUtils";

// const getPath = (x, y, width, height, borderRadius = 5) => {
//     const adjustedRadius = Math.min(borderRadius, width / 2, height / 2); // Ensure radius doesn't exceed dimensions

//     return `
//     M${x},${y} 
//     H${x + width - adjustedRadius} 
//     A${adjustedRadius},${adjustedRadius} 0 0 1 ${x + width},${y + adjustedRadius} 
//     V${y + height - adjustedRadius} 
//     A${adjustedRadius},${adjustedRadius} 0 0 1 ${x + width - adjustedRadius},${y + height} 
//     H${x} 
//     V${y} 
//     Z
//   `;
// };

// const CircularBar = (props) => {
//     const { fill, x, y, width, height, value } = props;
//     const formattedValue = formatNumberWithCommas(value);
//     return (
//         <>
//             <path d={getPath(x, y, width, height)} stroke="none" fill={fill} />
//             {/* Add label at the end of the bar */}
//             <text
//                 x={x + width + 5} // Position slightly beyond the bar
//                 y={y + height / 2} // Centered vertically
//                 fill="#333"
//                 fontSize="12"
//                 dominantBaseline="middle"
//             >
//                 {formattedValue}
//             </text>
//         </>
//     );
// };
// const generateTicks = (minValue, maxValue) => {
//     console.log(minValue, maxValue)
//     const maxAbs = Math.max(Math.abs(minValue), Math.abs(maxValue));
//     const step = maxAbs / 5; // Ensure equal spacing
    
//     return [...Array(11)].map((_, i) => (i - 5) * step);
//   };


// function findMinMax(data) {
//     let values = [];
    
//     data?.forEach(item => {
//         Object.keys(item).forEach(key => {
//             if (key !== "name" && item[key] !== null) {
//                 const num = parseFloat(item[key]);
//                 if (!isNaN(num)) {
//                     values.push(num);
//                 }
//             }
//         });
//     });
    
//     return {
//         min: Math.min(...values),
//         max: Math.max(...values)
//     };
// }

const generateTicks = (minValue, maxValue) => {
    const start = Math.ceil(minValue / 5) * 5;
    const end = Math.floor(maxValue / 5) * 5;
    const ticks = [];
    for (let i = start; i <= 0; i += 5) {
        ticks.push(i);
    }
    if (!ticks.includes(0)) {
        ticks.push(0);
    }
    for (let i = 5; i <= end; i += 5) {
        ticks.push(i);
    }
    return ticks;
};
const CustomTooltip = ({ active, payload, label }) => {
    return CustomTooltipPowerSteering(active, payload, label,'name','actual','plan','forecast');
	// if (active && payload && payload.length) {
	// 	return (
	// 		<div style={{ display: 'flex', flexDirection: 'column', background: '#fff', padding: 10 }}>
	// 			<div >{`${payload[0]['payload']['name']}`}</div>
	// 			{payload[0]['payload']['actual'] && 
    //                 <div style={{ color: "#0078A7" }}>Actual: {`${payload[0]['payload']['actual']}`}</div> }
	// 			{payload[0]['payload']['plan'] && 
    //                 <div style={{ color: "#B05788" }}>Plan: {`${payload[0]['payload']['plan']}`}</div> }
	// 			{payload[0]['payload']['forecast'] && 
    //                 <div style={{ color: "#FF891C" }}>Forecast: {`${payload[0]['payload']['forecast']}`}</div>}
	// 		</div>
	// 	);
	// }

	// return null;
};
function ThreeBarsChart({ data }) {
    const result = findMinMax(data, "name");
    
    const roundUpToNearest5 = (value) => Math.floor(value / 5) * 5;
    const roundUpToNearest5Positive = (value) => Math.ceil(value / 5) * 5;
    const minValue = result?.min>0?0:roundUpToNearest5(result?.min)
    const maxValue = result?.max<0?0:roundUpToNearest5Positive(result?.max)
    return (
        <div style={{ width: "100%", maxHeight: "450px", overflowY: "auto" }}>
            <div style={{ width: '100%', height: `${data.length * 100}px` }}>
                <ResponsiveContainer width="100%" height={"100%"} >
                    <ComposedChart
                        layout="vertical"
                        data={data}
                        margin={{
                            top: 20,
                            right: 30,
                            bottom: 25,
                            left: 10,
                        }}
                    >
                        <YAxis dataKey={"name"} tick={{ fontSize: 12, fontWeight: 500 }} type="category" scale="auto" axisLine={false} tickLine={false} width={270} />
                        <XAxis
                            dataKey={"plan"}
                            // label={{ value: xAxisLabel, offset: 9, position: "bottom", fill: '#616161' }}
                            type="number"
                            domain={[minValue,maxValue]} // * 1.2
                            axisLine={false} tickLine={false}
                            ticks={generateTicks(minValue, maxValue)}
                            // ticks={[...Array(6)].map((_, i) => Math.round((Math.round(chartMaxValue) / 5) * i))} // * 1.2
                            tickFormatter={formatNumberWithCommas} />
                        <Tooltip content={<CustomTooltip />} />
                        <CartesianGrid horizontal={false} vertical={true} />
                        <Bar
                            dataKey={"actual"}
                            barSize={10}
                            radius={[0, 10, 10, 0]} 
                            fill="#0078A7"
                        />
                        <Bar
                            dataKey={"plan"}
                            barSize={10}
                            radius={[0, 10, 10, 0]} 
                            fill="#B05788"
                        />
                        {/* <Bar
                            dataKey={"forecast"}
                            barSize={10}
                            radius={[0, 10, 10, 0]} 
                            fill="#FF891C"
                        /> */}
                    </ComposedChart>
                </ResponsiveContainer>
            </div>
        </div>
    )
}

export default ThreeBarsChart
